import React, {useState, useEffect, useContext} from "react";
import {HeadDropDown, LeftHead, TitleHead, RightHead, BodyDropDown} from "../../../../styles/ContentViews";
import {ButtonWithIcon, AppButton} from "../../../../styles/Butttons";
import {ReactComponent as SeeIcon} from "../../../../assets/icons/eye.svg";
import {ReactComponent as EditIcon} from "../../../../assets/icons/edit.svg";
import {ReactComponent as PlusIcon} from "../../../../assets/icons/plus.svg";
import Accordion from "../../../../components/accordion/Accordion";
import {EncabezadoItem} from "./Components";
import {Grid} from "../../../../styles/Grid";
import {LoadComponet} from "../../../../components/loaders/Loader";
import SuccesModal from "../../../../components/modals/SuccessModal";
import {orderDataByIndex} from "../../../../hooks/helpers";
import {HomeContext} from "../../../../context/HomeProvider";
import {PageWebUrl} from "../../../../services/ApiUrl";

export default function EncabezadoHome({theme, status, changeMode}) {
   const [editable, setEditable] = useState(false);
   const [showSuccess, setShowSuccess] = useState(false);
   // const [isLoading, setIsLoading] = useState({data: true});
   const [data, setData] = useState([]);
   const {getSlidesHome, slidesHome, isLoading, addClean} = useContext(HomeContext);

   useEffect(() => {
      getSlidesHome();
   }, []);

   return (
      <>
         <Accordion theme={theme} title="Texto/Imagen de Encabezado para home" status={status} changeMode={(val) => changeMode(val, 0)}>
            <>
               <HeadDropDown>
                  <LeftHead>
                     {!editable && (
                        <ButtonWithIcon
                           Icon={SeeIcon}
                           text="Vista previa"
                           action={() => {
                              window.open(PageWebUrl, "_blank");
                           }}
                        />
                     )}
                  </LeftHead>
                  <TitleHead>Recuerda! Solo se puede agregar 5 imágenes</TitleHead>
                  <RightHead>
                     {!editable ? (
                        <ButtonWithIcon
                           right={true}
                           Icon={EditIcon}
                           action={() => {
                              setEditable(true);
                           }}
                           text=""
                        />
                     ) : (
                        slidesHome.length < 5 && (
                           <ButtonWithIcon classname="text" right={false} Icon={PlusIcon} action={addClean} text="Agregar otro" />
                        )
                     )}
                  </RightHead>
               </HeadDropDown>
               <BodyDropDown>
                  {!isLoading.slides ? (
                     <Grid>
                        {slidesHome.map((item, index) => (
                           <EncabezadoItem editable={editable} data={item} key={index} />
                        ))}
                     </Grid>
                  ) : (
                     <LoadComponet isVisible={true} />
                  )}
               </BodyDropDown>
               <SuccesModal theme={theme} isOpen={showSuccess} close={() => setShowSuccess(false)} />
            </>
         </Accordion>
      </>
   );
}

/* 
idSlideHome: 2
title: " Título 1"
subtitle: "Subtitlulo"
pathImageWebDesktop: "media/homeBlock/desktop/1585436142647.jpg"
pathImageWebMobile: "media/homeBlock/mobile/1585436142647.jpg"
url: " http://google.com"
*/

const dataItems = [
   {
      idSlideHome: 0,
      title: "Título de encabezado 1",
      subtitle: "Subtítulo de encabezado 1",
      link: "https://reacttraining.com/react-router/web/api/Redirect",
      pathImageWebDesktop: "media/homeBlock/desktop/1585436142647.jpg",
      pathImageWebMobile: "media/homeBlock/mobile/1585436142647.jpg",
   },
   {
      idSlideHome: 1,
      title: "Título de encabezado 2",
      subtitle: "Subtítulo de encabezado 2",
      link: "https://reacttraining.com/react-router/web/api/Redirect",
      pathImageWebDesktop: "media/homeBlock/desktop/1585436142647.jpg",
      pathImageWebMobile: "media/homeBlock/mobile/1585436142647.jpg",
   },
];
